import "regenerator-runtime/runtime";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.replace";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
import cookie from '@tencent/vft-common/cookie';
import env from '@tencent/vft-common/env';
import { COOKIE_EXPIRED_TIME, USERINFO_COOKIE, VIDEO_COOKIES } from "./config";
import IframeCookieLoader from "./IframeCookieLoader";

// 删除cookie
function removeCookie(key, domain) {
  cookie.remove(key, {
    domain: domain,
    path: '/'
  });
  // 避免cookie有种在没domain或者没路径的域名，导致无法清cookie
  cookie.remove(key, {
    domain: domain,
    path: ''
  });
  cookie.remove(key, {
    path: '/'
  });
}

// 清除用户信息相关污染的cookie，没domain或没路径的cookie
export function clearErrorCookies() {
  var domain = getDomain();
  // 清除上次续期的时间
  USERINFO_COOKIE.concat(['last_refresh_time', 'last_refresh_vuserid']).forEach(function (key) {
    cookie.remove(key, {
      domain: domain,
      path: ''
    });
    cookie.remove(key, {
      path: '/'
    });
  });
}

/**
 * 获取当前需要同步 cookie 的域名
 * @returns {String}
 */
export function getDomain() {
  var domain = location.host;

  // 支持域名：(*.)?film.qq.com, (*.)?v.qq.com, *.video.qq.com
  if (!/(film|v|kf)\.qq\.com$/.test(domain) && !/\.video\.qq\.com$/.test(domain)) {
    return '';
  }
  var arr = domain.split('.');
  var len = arr.length;
  if (len <= 3 || /\.video\.qq\.com$/.test(domain)) {
    return domain;
  }
  return arr.slice(len - 3, len).join('.');
}

/**
 * 清除所有视频 cookie
 */
export function clearVideoCookies() {
  var domain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'qq.com';
  VIDEO_COOKIES.forEach(function (key) {
    removeCookie(key, domain);
  });
}

/**
 * 清除 qq.com 域下的 cookie 信息
 * 一般用于非 app 场景，如果存在 qq.com 的 cookie，会导致与 video.qq.com 源 cookie 冲突
 */
export function clearRootDomainCookies() {
  clearVideoCookies('qq.com');
}

/**
 * 清除video.qq.com域下cookie
 */
export function clearVideoDomainCookies() {
  return _clearVideoDomainCookies.apply(this, arguments);
}

/**
 * 清除当前域下的 cookie 信息
 */
function _clearVideoDomainCookies() {
  _clearVideoDomainCookies = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", IframeCookieLoader.getInstance().clearVideoCookie().catch(function () {
              return null;
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _clearVideoDomainCookies.apply(this, arguments);
}
export function clearPageCookies() {
  var domain = getDomain();
  var isFilmVideoDomain = /film\.video\.qq\.com/.test(domain);
  if (isFilmVideoDomain || !domain || !/([^.]+\.){2,}qq\.com/.test(location.hostname)) {
    return;
  }
  VIDEO_COOKIES.forEach(function (key) {
    removeCookie(key, domain);
  });
}

// 清除刷票cache
export function clearRefreshTimeCookies() {
  // 清除上次续期的时间
  removeCookie('last_refresh_time', getDomain());
  removeCookie('last_refresh_vuserid', getDomain());
}
export function clearUserCookies() {
  var domain = getDomain();
  USERINFO_COOKIE.forEach(function (key) {
    removeCookie(key, domain);
  });
}

/**
 * 判断当前是否是 Native 登录环境
 * @returns {Boolean}
 */
export function isNativeLogin() {
  return /video_platform=[3-6]/.test(document.cookie) || env.isTenvideoUnion;
}

/**
 * 获取登录态类型
 */
export function loginType() {
  var loginType = cookie.get('main_login');
  if (loginType === 'none') {
    return '';
  }
  return loginType || '';
}

/**
 * 是否是新的互联登录态
 */
export function isNewQQLogin() {
  if (loginType() === 'wx') return false;
  if (loginType() === 'qq' && cookie.get('vqq_appid') && cookie.get('vqq_openid') && cookie.get('vqq_access_token')) {
    return true;
  }
  return false;
}

/**
 * 是否已经登录
 * 不仅单纯仅判断是否有 main_login 就代表已登录
 * 通过 cookie 中是否存在登录态对应的存在关键信息来决定
 * @param {String} type 可获取指定登录态类型的登录态
 */
export function isLogin(type) {
  if (!type) type = loginType();
  var vuserid = isNewQQLogin() ? cookie.get('vqq_vuserid') : cookie.get('vuserid');
  var vusession = isNewQQLogin() ? cookie.get('vqq_vusession') : cookie.get('vusession');

  // cookie 中的 type 可能返回 none
  if (!type || type === 'none' || !vuserid || !vusession) {
    // 不存在视频票据时未登录
    return false;
  }
  if (type === 'wx') {
    return isWXLogin();
  }
  if (type === 'qq') {
    return isQQLogin();
  }
  return true;
}

/**
 * 判断是否微信登录态
 */
export function isWXLogin() {
  if (loginType() === 'wx' && cookie.get('appid') && cookie.get('openid') && cookie.get('access_token')) {
    return true;
  }
  return false;
}

/**
 * 判断是否 QQ 登录态
 */
export function isQQLogin() {
  return isPTLogin() || isNewQQLogin();
}

/**
 * 是否是旧版 PTLogin 登录态
 */
export function isPTLogin() {
  if (loginType() === 'wx') return false;
  if (!isNewQQLogin() && (cookie.get('uin') && cookie.get('skey') || cookie.get('luin') && cookie.get('lskey'))) {
    return true;
  }
  return false;
}

/**
 * 获取视频 vuserid
 * @returns {string}
 */
export function getVuid() {
  return isNewQQLogin() ? cookie.get('vqq_vuserid') : cookie.get('vuserid');
}

/**
 * 获取登录态信息，去掉QQ登录态的 prefix vqq_
 * @returns
 */
export function getLoginInfo() {
  if (!isLogin()) return null;
  var type = loginType();
  var prefix = type === 'qq' ? 'vqq_' : '';
  return {
    type: loginType(),
    appid: cookie.get("".concat(prefix, "appid")),
    openid: cookie.get("".concat(prefix, "openid")),
    accessToken: cookie.get("".concat(prefix, "access_token")),
    vuserid: cookie.get("".concat(prefix, "vuserid")),
    vusession: cookie.get("".concat(prefix, "vusession"))
  };
}

/**
 * 获取用户昵称
 * @returns {string}
 */
export function getNick() {
  if (!isLogin()) return '';
  var nick = cookie.get("".concat(loginType(), "_nick"));
  try {
    return decodeURIComponent(nick);
  } catch (error) {
    return nick;
  }
}

/**
 * 获取用户头像
 * @returns {string}
 */
export function getAvatar() {
  if (!isLogin()) return '';
  try {
    return decodeURIComponent(cookie.get("".concat(loginType(), "_head")));
  } catch (e) {
    return '';
  }
}

/**
 * 获取登录账号 id
 * @returns {string|number}
 */
export function getUid() {
  var type = loginType();
  if (!type) return '';
  if (type === 'qq') {
    return isNewQQLogin() ? cookie.get('vqq_openid') : '';
  }
  return cookie.get('openid');
}

/**
 * 获取QQ号
 * @deprecated
 * @returns {number}
 */
export function getUin() {
  if (getSkey() === '') {
    return 0;
  }
  var uin = parseInt(cookie.get('uin').replace(/^o0*/g, ''), 10);
  if (!uin || uin < 10000) {
    uin = parseInt(cookie.get('luin').replace(/^o0*/g, ''), 10);
    if (!uin || uin < 10000) {
      return 0;
    }
  }
  return uin;
}

/**
 * 获取 skey
 * @returns {string} skey
 * @deprecated
 */
export function getSkey() {
  var skey = cookie.get('skey') || cookie.get('lskey');
  return skey ? skey.trim() : '';
}

/**
 * 获取 PTLogin token
 * @returns {string}
 * @deprecated
 */
export function getToken() {
  var skey = getSkey();
  return skey ? time33(skey) : '';
}

/**
 * 哈希time33算法
 */
export function time33(skey) {
  var hash = 5381;
  for (var i = 0, len = skey.length; i < len; ++i) {
    hash += (hash << 5) + skey.charAt(i).charCodeAt();
  }
  return hash & 0x7fffffff;
}

/**
 * 设置用户信息到 Cookie 里
 * @param {*} userInfo
 * @returns
 */
export function setUserInfo() {
  var userInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var type = arguments.length > 1 ? arguments[1] : undefined;
  if (!userInfo) return;
  var options = {
    domain: getDomain(),
    expires: COOKIE_EXPIRED_TIME,
    path: '/'
  };
  if (options.domain) {
    if (!type) {
      type = loginType();
    }
    cookie.set("".concat(type, "_nick"), encodeURIComponent(userInfo.nick), options);
    cookie.set("".concat(type, "_head"), encodeURIComponent(userInfo.head), options);
  }
}
export function generateGuid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }
  return [s4(), s4(), s4(), s4()].join('');
}